module.exports = __webpack_public_path__ + "static/media/email-icon.babde28a.png";